// @flow
import React, { type Node } from 'react';
import { getWeekDay } from '@tectonics/prs/week-day';
import {
  getSafeDueDate,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { ArgentineCashInformation } from './argentine-cash-information';
import { DisplayBarcode } from '../commons/display-barcode';
import { ShowBarcodePdfButton } from './show-barcode-pdf-button';
import { DisplayBarcodeNumber } from '../commons/display-barcode-number';
import { ButtonWrapper } from '../commons/render-helpers';
import { VoucherNumberBox } from '../commons/voucher-number-box';
import { VoucherText } from '../commons/voucher/voucher-text';
import { Separator } from '../../../atoms';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../organisms/display-total-amount';
import {
  DashedHr,
  PaymentInfoWrapper,
} from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';

export function RenderTotalDueDateAndBarCode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <>
      <PaymentInfoWrapper>
        <DisplayTotalAmount label="Valor a pagar" location="left" redesign={true} />
        <DisplayDueDate label="Fecha de Vencimiento" sublabel={`Pagar hasta el ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true}  />
        <VoucherNumberBox redesign={true}>
          <VoucherText>Código de su orden de pago</VoucherText>
          <DisplayBarcode countryCode="AR" />
          <DisplayBarcodeNumber redesign={true} />
        </VoucherNumberBox>
      </PaymentInfoWrapper>
      <Separator direction="vertical" size={3} />
    </>
  );
}

export function RenderButtonArea(): Node {
  return (
    <>
      <ButtonWrapper>
        <ShowBarcodePdfButton format="pdf" buttonMessage="Guardar orden de pago en pdf"/>
      </ButtonWrapper>
      <ButtonWrapper>
        <ShowBarcodePdfButton inverseStyle={true} buttonMessage="Imprimir orden de pago"/>
      </ButtonWrapper>
    </>
  );
}

export function RenderPaymentInstructions(): Node {
  return (
    <>
      <DashedHr />
      <ArgentineCashInformation />
      <DashedHr />

      <RenderPaymentInfoContainer
        bgColor="#ffffff"
        h1Text="Instrucciones de pago"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/calendar-icon.svg',
            subText: 'La confirmación del pago puede llevar aproximadamente 3 días hábiles para verse reflejado en el sitio web de la compra.',
          },
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/duplicate-icon.svg',
            subText: 'Este voucher es válido solamente para un código de pedido, no debe realizar un pago doble o uno de ellos será cancelado.',
          },
        ]}
      />

      <RenderPaymentInfoContainer
        h1Text="¿Ya conoces la Central de Ayuda EBANX?"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/files-icon.svg',
            subText: 'Si tienes dudas adicionales acerca de tu pago, o tu reembolso visítanos en la Central de Ayuda EBANX:',
            strong:  'ayuda.ebanx.com/hc/es-ar',
          },
        ]}
      />
    </>
  );
}

const dueDateWeekDay = [
  'lunes',
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'lunes',
];
